var _path, _line, _line2, _line3, _path2, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _rect, _rect2, _line11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebdevkatlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 32.5C51 42.6936 42.5174 51 32 51C21.4826 51 13 42.6936 13 32.5C13 22.3064 21.4826 14 32 14C42.5174 14 51 22.3064 51 32.5Z",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 22.3607,
    y2: -1,
    transform: "matrix(0.98387 -0.178885 0.588172 0.808736 34 37)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 28.0713,
    y2: -1,
    transform: "matrix(0.997459 0.071247 -0.274721 0.961524 34 37)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 19.6977,
    y2: -1,
    transform: "matrix(0.913812 0.406138 -0.871575 0.490261 34 37)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 41L28.6029 33.5H36.3971L32.5 41Z",
    fill: "#F7F8FA"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 20.0396,
    y2: -1,
    transform: "matrix(-0.979877 -0.199604 0.696146 -0.7179 31 36)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 24.0832,
    y2: -1,
    transform: "matrix(-0.996546 0.0830455 -0.36874 -0.929533 31 36)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1,
    x2: 21.6006,
    y2: -1,
    transform: "matrix(-0.909065 0.416655 -0.909065 -0.416655 31 36)",
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 18.0256,
    y1: 19.7751,
    x2: 21.0256,
    y2: 6.77514,
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 30.4453,
    y1: 13.8321,
    x2: 21.4453,
    y2: 7.83205,
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 34.4631,
    y1: 14.1563,
    x2: 45.4631,
    y2: 7.15634,
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 19,
    x2: 45,
    y2: 8,
    stroke: "#F7F8FA",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 20,
    width: 16,
    height: 9,
    stroke: "#FF89A5",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 20,
    width: 16,
    height: 9,
    stroke: "#FF89A5",
    strokeWidth: 2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 24,
    x2: 33,
    y2: 24,
    stroke: "#FF89A5",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebdevkatlogo);
export default __webpack_public_path__ + "static/media/webdevkatlogo.02d5ba8ef76354560e478af14cf41b5a.svg";
export { ForwardRef as ReactComponent };